import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import styles from './SubjectItemCategories.module.scss';
import { createCategory, createFolder, deleteCategory, deleteFolder, deleteSubcategory, deleteSubfolder, onCheckCategories, onCheckSubcategories, updateCategory, updateFolder } from '../../../../actions';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { FcFolder, FcOpenedFolder } from "react-icons/fc";
import { MdArrowDownward, MdArrowDropDown, MdArrowRight, MdOutlineFolder, MdOutlineFolderDelete, MdImportExport } from "react-icons/md";
import { Checkbox, Dropdown, Modal, Space, message } from 'antd';
import { FaCode, FaEye } from "react-icons/fa";
import { DownOutlined, SmileOutlined } from '@ant-design/icons';
import { IoSettingsSharp } from "react-icons/io5";
import { MdOutlineCreateNewFolder } from "react-icons/md";
import i18n from '../../../../../../lib/i18n';
// import FormData from '../../../Categories/components/FormData/FormData';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { reset } from 'redux-form';
import sign from 'jwt-encode'
import config from '../../../../../../config';
import FormData from '../../../Folders/components/FormData/FormData';
const { confirm } = Modal;

function SubjectItemCategories({ subject = {}, setUpdateItem, onDeleteItem }) {
  const [messageApi, contextHolder] = message.useMessage();
  const [show, setShow] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [showModalSubfolder, setShowModalSubfolder] = useState(false)
  const [item, setItem] = useState({})

  let categories = useSelector(state => state.slider.subfolders);
  let folders = useSelector(state => state.slider.folders);
  const subcategories = useSelector(state => state.slider.subfolders);
  const checkCategories = useSelector(state => state.slider.checkCategories) || [];
  const checkSubcategories = useSelector(state => state.slider.checkSubcategories) || [];
  const dispatch = useDispatch()

  const subjectCategoryIds = categories.filter(_c => _c.parent_id == subject.id).map(_c => _c.id)
  const hasChecked = checkCategories.some(_id => subjectCategoryIds.includes(_id))
    || subcategories.some(_s => subjectCategoryIds.includes(_s.parent_id) && checkSubcategories.includes(_s.id))

  // Expand only when something inside becomes checked, so the user can still collapse it
  useEffect(() => {
    if (hasChecked) setShow(true)
  }, [hasChecked])

  const onSave = async (values) => {
    try {
      const tmp = { ...values }
      if (values.sub_parent_id) {
        tmp.parent_id = tmp.sub_parent_id
      }
      if (values.id) {
        await dispatch(updateFolder(tmp));
        messageApi.open({
          type: 'success',
          content: i18n('qn_cat_msg_updated'),
        });
        setShowModal(false)
      } else {
        await dispatch(createFolder(tmp));
        messageApi.open({
          type: 'success',
          content: i18n('qn_cat_msg_created'),
        });
        confirm({
          autoFocusButton: null,
          title: i18n('qn_cat_title_confirn'),
          icon: <ExclamationCircleFilled />,
          content: i18n('qn_cat_msg_confirn'),
          onOk() {
            dispatch(reset('category'))
          },
          onCancel() {
            setShowModal(false)
          },
        });
      }
    } catch (error) {
      console.log("🚀 ~ file: Categories.jsx:60 ~ onSave ~ error:", error)

    }
  }

  return (
    <div
      className={classNames(styles.SubjectItemCategories)}
    // onClick={() => dispatch(selectSubject(subject.id))}
    >
      {contextHolder}
      <FormData
        open={showModal || showModalSubfolder}
        onClose={() => {
          setShowModal(false)
          setShowModalSubfolder(false)
        }}
        initialValues={item}
        onSave={onSave}
        folders={folders}
        subfolders={categories}
        type={showModal ? 'category' : showModalSubfolder ? 'subcategory' : ''}
      />
      <div className={classNames(styles.item_subject)}>
        <div className={styles.icon} onClick={() => setShow(!show)}>
          {show ? <MdArrowDropDown size={24} /> : <MdArrowRight size={24} />}
        </div>
        <div className={styles.text} onClick={() => setShow(!show)}>{show ? <FcOpenedFolder size={21} /> : <FcFolder size={21} />}{subject.title}</div>
        <Dropdown
          trigger={['click']}
          menu={{
            items: [
              {
                key: 'update_subject',
                label: i18n('qn_update_subject'),
                icon: <MdOutlineFolder size={18} />,
                onClick: setUpdateItem,
              },
              {

                key: 'create_category',
                label: i18n('qn_create_category'),
                icon: <MdOutlineCreateNewFolder size={18} />,
                // disabled: true,
                onClick: () => {
                  setItem({ parent_id: subject.id });
                  setShow(true);
                  setShowModal(true);
                }
              },
              {
                key: '3',
                icon: <MdOutlineFolderDelete size={18} />,
                danger: true,
                label: i18n('qn_delete_subject'),
                onClick: onDeleteItem
              },
            ],
          }}
        >
          <IoSettingsSharp style={{ cursor: 'pointer' }} />
        </Dropdown>
      </div>
      {show && <div className={styles.categories}>
        {categories.filter(_c => _c.parent_id == subject.id).map(_i => <div key={'category_' + _i.id} className={styles.item_block}>
          <div
            className={classNames(styles.item)}
          >
            <div onClick={(e) => { e.stopPropagation() }}>
              <Checkbox
                checked={checkCategories.includes(_i.id)}
                onChange={() => {
                  if (checkCategories.includes(_i.id)) {
                    dispatch(onCheckCategories([...checkCategories.filter(_id => _id != _i.id)]))
                    dispatch(onCheckSubcategories([...checkSubcategories.filter(_id => !subcategories.filter(_s => _s.parent_id == _i.id).map(_s => _s.id).includes(_id))]))
                  } else {
                    dispatch(onCheckCategories([...checkCategories, _i.id]))
                    dispatch(onCheckSubcategories([...checkSubcategories, ...subcategories.filter(_s => _s.parent_id == _i.id).map(_s => _s.id)]))
                  }
                }} />
            </div>
            <div className={styles.text}>
              {_i.title}
            </div>
            <div className={styles.actions}>
              <Dropdown
                trigger={['click']}
                menu={{
                  items: [
                    {
                      key: '1',
                      label: i18n('qn_create_subcategory'),
                      icon: <MdOutlineCreateNewFolder size={18} />,
                      onClick: () => {
                        setShowModalSubfolder(true);
                        setItem({
                          parent_id: _i.parent_id,
                          sub_parent_id: _i.id,
                        })
                      }
                      // disabled: true,
                    },
                    {
                      key: '2',
                      label: i18n('qn_update_category'),
                      icon: <MdOutlineFolder size={18} />,
                      onClick: () => {
                        setShowModal(true);
                        setItem(_i)
                      }
                      // disabled: true,
                    },
                    {
                      key: '3',
                      icon: <MdOutlineFolderDelete size={18} />,
                      danger: true,
                      label: i18n('qn_delete_category'),
                      onClick: () => {
                        Modal.confirm({
                          autoFocusButton: null,
                          title: i18n('qn_category_title_delete'),
                          content: i18n('qn_category_msg_delete'),
                          okText: i18n("Yes"),
                          cancelText: i18n("No"),
                          onOk: () => {
                            dispatch(deleteSubfolder(_i.id))
                          }
                        });
                      }
                    },
                  ],
                }}
              >
                <IoSettingsSharp style={{ cursor: 'pointer' }} />
              </Dropdown>
            </div>
          </div>
          <div className={styles.subcategory}>
            {subcategories.filter(_s => _s.parent_id == _i.id).map(_s =>
              <div
                key={'subcategory_' + _s.id}
                className={classNames(styles.item, styles.subitem)}
              // onClick={() => dispatch(selectSubcategory(_s.id))}
              >
                <div onClick={(e) => { e.stopPropagation() }}>
                  <Checkbox
                    checked={checkSubcategories.includes(_s.id)}
                    onChange={() => {
                      if (checkSubcategories.includes(_s.id)) {
                        dispatch(onCheckSubcategories([...checkSubcategories.filter(_id => _id != _s.id)]))
                      } else {
                        dispatch(onCheckSubcategories([...checkSubcategories, _s.id]))
                      }
                    }}
                  />
                </div>
                <div className={styles.text}>
                  {_s.title}
                </div>
                <div className={styles.actions}>
                  <Dropdown
                    trigger={['click']}
                    menu={{
                      items: [
                        {
                          key: '2',
                          label: i18n('qn_update_subcategory'),
                          icon: <MdOutlineFolder size={18} />,
                          // disabled: true,
                          onClick: () => {
                            // setShowModal(true);
                            setShowModalSubfolder(true);
                            setItem({
                              ..._s,
                              parent_id: _i.parent_id,
                              sub_parent_id: _i.id,
                            })
                            // setItem(_s)
                          }
                        },
                        {
                          key: '3',
                          icon: <MdOutlineFolderDelete size={18} />,
                          danger: true,
                          label: i18n('qn_delete_subcategory'),
                          onClick: () => {
                            Modal.confirm({
                              autoFocusButton: null,
                              title: i18n('qn_subcategory_title_delete'),
                              content: i18n('qn_subcategory_msg_delete'),
                              okText: i18n("Yes"),
                              cancelText: i18n("No"),
                              onOk: () => {
                                // dispatch(deleteCategory(selectCategoryId))
                                dispatch(deleteSubfolder(_s.id))
                              }
                            });
                          }
                        },
                      ],
                    }}
                  >
                    <IoSettingsSharp style={{ cursor: 'pointer' }} />
                  </Dropdown>
                </div>
              </div>
            )}
          </div>
        </div>)}
      </div>}
    </div>
  )
}

export default SubjectItemCategories